import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
//import promise from 'redux-promise-middleware';
//import axiosMiddleware from 'redux-axios-middleware';
//import axios from 'axios';

import reducers from '../_reducers';

const configureStore = () => {

    const middleware = [];

    // const axiosClient = axios.create({
    //     baseURL: 'https://gstablesserver.grandsova.com',
    //     //baseURL: 'http://127.0.0.1:9900',
    //     responseType: 'json',
    // });

    // const axiosConfig = {
    //     interceptors: {
    //         request: [
    //             ({ getState }, config) => {
    //                 config.headers['Authorization'] = getState().user.token;
    //                 //config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    //                 return config
    //             }
    //         ]
    //     }                
    // };

    // middleware.push(axiosMiddleware(axiosClient, axiosConfig));
    middleware.push(thunk);
    //middleware.push(promise());
    //middleware.push(createLogger());
    
    const store = createStore(
        reducers,
        applyMiddleware(...middleware)
    );  

    return store;

};

export { configureStore }


// WEBPACK FOOTER //
// ./src/_store/index.js